export default (data, key) => {
  const [i, j, k] = key.split(',').map(n => Number(n))
  const g = (Math.abs(i) + Math.abs(j)) % 2 === 0 ? '0' : '1'
  if (k === 0) return `${g}${k}0`

  const variant = v => `${g}${k}${v}`

  switch (k) {
    case 1: // NE
      if (data[`${i + 1},${j - 1},0`]) return variant('3') // full if has NE neighbor
      if (data[`${i},${j - 1},0`]) return variant('2') // 1/2v if has N neighbor
      if (data[`${i + 1},${j},0`]) return variant('1') // 1/2h if has E neighbor
      return variant('0') // 1/4 if has no neighbors
    case 2: // SE
      if (!data[`${i + 1},${j},0`] && !data[`${i},${j + 1},0`]) {
        return variant('0') // 1/4 if has no E and S neighbors
      }
      return null // no block otherwise
    case 3: // SW
      if (data[`${i - 1},${j + 1},0`]) return null // no block if has SW neighbor
      if (data[`${i},${j + 1},0`]) return variant('2') // 1/2v if has S neighbor
      if (data[`${i - 1},${j},0`]) return variant('1') // 1/2h if has W neighbor
      return variant('0') // 1/4 if has no neighbors
    case 4: // NW
      if (!data[`${i - 1},${j},0`] && !data[`${i},${j - 1},0`]) {
        return variant('0')  // 1/4 if has no W and N neighbors
      }
      return null // no block otherwise
  }
}



// WEBPACK FOOTER //
// ./src/client/lib/spinneybeck/get-sp402-variant.js